/* eslint-disable react-refresh/only-export-components */
import { buildingLoader } from "./api/building";
import { cityLoader } from "./api/city";
import { organizationLoader } from "./api/organization";
import { provinceLoader } from "./api/province";
import { subdistrictLoader } from "./api/subdistrict";
import { villageLoader } from "./api/village";
import { RoleGate } from "./components/role-gate";
import { UserGate } from "./components/user-gate";
import { Layout } from "./layout/Layout";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { ErrorPage } from "./pages/ErrorPage";
import { APDCreate } from "./pages/master-data/apd/APDCreate";
import { APDEdit } from "./pages/master-data/apd/APDEdit";
import { APDEditBulk } from "./pages/master-data/apd/APDEditBulk";
import { APDIndex } from "./pages/master-data/apd/APDIndex";
import { BuildingCreate } from "./pages/master-data/building/BuildingCreate";
import { BuildingDetail } from "./pages/master-data/building/BuildingDetail";
import { BuildingEdit } from "./pages/master-data/building/BuildingEdit";
import { BuildingIndex } from "./pages/master-data/building/BuildingIndex";
import { CityCreate } from "./pages/master-data/city/CityCreate";
import { CityDetail } from "./pages/master-data/city/CityDetail";
import { CityEdit } from "./pages/master-data/city/CityEdit";
import { CityIndex } from "./pages/master-data/city/CityIndex";
import { OrganizationCreate } from "./pages/master-data/organization/OrganizationCreate";
import { OrganizationDetail } from "./pages/master-data/organization/OrganizationDetail";
import { OrganizationEdit } from "./pages/master-data/organization/OrganizationEdit";
import { OrganizationIndex } from "./pages/master-data/organization/OrganizationIndex";
import { ProvinceCreate } from "./pages/master-data/province/ProvinceCreate";
import { ProvinceDetail } from "./pages/master-data/province/ProvinceDetail";
import { ProvinceEdit } from "./pages/master-data/province/ProvinceEdit";
import { ProvinceIndex } from "./pages/master-data/province/ProvinceIndex";
import { SubdistrictCreate } from "./pages/master-data/subdistrict/SubdistrictCreate";
import { SubdistrictDetail } from "./pages/master-data/subdistrict/SubdistrictDetail";
import { SubdistrictEdit } from "./pages/master-data/subdistrict/SubdistrictEdit";
import { SubdistrictIndex } from "./pages/master-data/subdistrict/SubdistrictIndex";
import { VillageCreate } from "./pages/master-data/village/VillageCreate";
import { VillageDetail } from "./pages/master-data/village/VillageDetail";
import { VillageEdit } from "./pages/master-data/village/VillageEdit";
import { VillageIndex } from "./pages/master-data/village/VillageIndex";
import { RFSCreate } from "./pages/rfs-submission/rfs/RFSCreate";
import { RFSDetail } from "./pages/rfs-submission/rfs/RFSDetail";
import { RFSEdit } from "./pages/rfs-submission/rfs/RFSEdit";
import { RFSIndex } from "./pages/rfs-submission/rfs/RFSIndex";
import { RFSReassign } from "./pages/rfs-submission/rfs/RFSReassign";
import { GPONCreate } from "./pages/rfs-submission/rfs/gpon/GPONCreate";
import { HPTARCreate } from "./pages/rfs-submission/rfs/hptar/HPTARCreate";
import { NNEvidenceCreate } from "./pages/rfs-submission/rfs/nn-evidence/NNEvidenceCreate";
import { OPMCreate } from "./pages/rfs-submission/rfs/opm/OPMCreate";
import { ROLE } from "./utils/constant";
import { queryClient } from "./utils/lib/queryClient";
import Profile from "./pages/Profile";
import { profileLoader } from "./api/profile";
import LogHistory from "./pages/rfs-submission/rfs/log-history/LogHistory";
import { MasterParamIndex } from "./pages/master-data/master-param/MasterParamIndex";
import { MasterParamCreate } from "./pages/master-data/master-param/MasterParamCreate";
import { masterParamLoader } from "./api/master-param";
import { MasterParamDetail } from "./pages/master-data/master-param/MasterParamDetail";
import { MasterParamEdit } from "./pages/master-data/master-param/MasterParamEdit";
import { MapIndex } from "./pages/map/MapIndex";
import { e2eRoutes } from "./e2e.routes";
import { rebuildRoutes } from "./rebuild.routes";
import { e2ePhase2Routes } from "./e2e-phase2.routes";
import Landing from "./pages/Landing";
import { lazy, Suspense } from "react";
import { Loading } from "./components/ui/loading";
import { keycloak } from "./utils/lib/keycloak";
import NotificationIndex from "./pages/notifications/NotificationIndex";
import { abdBackboneRoutes } from "./abd-backbone.routes";

//Master Matrix Approval
const MasterMatrixApprovalCreate = lazy(
  () => import("e2ePhase2/MasterMatrixApprovalCreate"),
);
const MasterMatrixApprovalDetail = lazy(
  () => import("e2ePhase2/MasterMatrixApprovalDetail"),
);
const MasterMatrixApprovalIndex = lazy(
  () => import("e2ePhase2/MasterMatrixApprovalIndex"),
);

export const routes = [
  {
    path: "/",
    element: (
      <UserGate>
        <Layout />
      </UserGate>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Landing />,
      },
      {
        path: "dashboard",
        children: [
          {
            path: "nro",
            element: (
              <RoleGate
                roles={[
                  ROLE.ADMINISTRATOR,
                  ROLE.VALIDATOR_DOCUMENT_OFFICER,
                  ROLE.REVISE_DOCUMENT_OFFICER,
                  ROLE.MONITORING_TEAM,
                  ROLE.VENDOR,
                  ROLE.VENDOR_VIEW,
                ]}
              >
                <Dashboard />
              </RoleGate>
            ),
          },
          {
            path: "rebuild",
            element: <> Dashboard Rebuild </>,
          },
        ],
      },
      {
        path: "profile",
        children: [
          {
            index: true,
            element: <Profile />,
            loader: profileLoader(queryClient),
          },
        ],
      },
      {
        path: "rfs",
        children: [
          {
            path: "rfs",
            children: [
              {
                index: true,
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.VENDOR_VIEW,
                    ]}
                  >
                    <RFSIndex />
                  </RoleGate>
                ),
              },
              {
                path: "create",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                    ]}
                  >
                    <RFSCreate />
                  </RoleGate>
                ),
              },
              {
                path: ":id",
                children: [
                  {
                    index: true,
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <RFSDetail />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "opm/create",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <OPMCreate />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "gpon/create",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <GPONCreate />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "nn-evidence/create",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <NNEvidenceCreate />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "hptar/create",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <HPTARCreate />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "draft",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                        ]}
                      >
                        <RFSEdit />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "log-history",
                    element: (
                      <RoleGate
                        roles={[
                          ROLE.ADMINISTRATOR,
                          ROLE.MONITORING_TEAM,
                          ROLE.REVISE_DOCUMENT_OFFICER,
                          ROLE.VALIDATOR_DOCUMENT_OFFICER,
                          ROLE.VENDOR,
                          ROLE.VENDOR_VIEW,
                        ]}
                      >
                        <LogHistory />
                      </RoleGate>
                    ),
                  },
                  {
                    path: "reassign",
                    element: (
                      <RoleGate roles={[ROLE.ADMINISTRATOR]}>
                        <RFSReassign />
                      </RoleGate>
                    ),
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "master-data",
        children: [
          {
            path: "apd",
            children: [
              {
                index: true,
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.SYS_ADMIN,
                      ROLE.SYS_ADMIN_VIEW,
                      ROLE.VENDOR_VIEW,
                    ]}
                  >
                    <APDIndex />
                  </RoleGate>
                ),
              },
              {
                path: "create",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.SYS_ADMIN,
                    ]}
                  >
                    <APDCreate />
                  </RoleGate>
                ),
              },
              {
                path: "edit/bulk",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.SYS_ADMIN,
                    ]}
                  >
                    <APDEditBulk />
                  </RoleGate>
                ),
              },
              {
                path: ":id/edit",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.SYS_ADMIN,
                    ]}
                  >
                    <APDEdit />
                  </RoleGate>
                ),
              },
              {
                path: ":id",
                element: (
                  <RoleGate roles={[ROLE.SYS_ADMIN_VIEW, ROLE.VENDOR_VIEW]}>
                    <APDEdit />
                  </RoleGate>
                ),
              },
            ],
          },
          {
            path: "subdistrict",
            children: [
              {
                index: true,
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.VENDOR,
                      ROLE.SYS_ADMIN,
                      ROLE.SYS_ADMIN_VIEW,
                      ROLE.VENDOR_VIEW,
                    ]}
                  >
                    <VillageIndex />
                  </RoleGate>
                ),
              },
              {
                path: "create",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.SYS_ADMIN,
                    ]}
                  >
                    <VillageCreate />
                  </RoleGate>
                ),
              },
              {
                path: ":id",
                element: <VillageDetail />,
                loader: villageLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: (
                  <RoleGate
                    roles={[
                      ROLE.ADMINISTRATOR,
                      ROLE.MONITORING_TEAM,
                      ROLE.REVISE_DOCUMENT_OFFICER,
                      ROLE.VALIDATOR_DOCUMENT_OFFICER,
                      ROLE.SYS_ADMIN,
                    ]}
                  >
                    <VillageEdit />
                  </RoleGate>
                ),
                loader: villageLoader(queryClient),
              },
            ],
          },
          {
            path: "district",
            children: [
              {
                index: true,
                element: <SubdistrictIndex />,
              },
              {
                path: "create",
                element: <SubdistrictCreate />,
              },
              {
                path: ":id",
                element: <SubdistrictDetail />,
                loader: subdistrictLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <SubdistrictEdit />,
                loader: subdistrictLoader(queryClient),
              },
            ],
          },
          {
            path: "city",
            children: [
              {
                index: true,
                element: <CityIndex />,
              },
              {
                path: "create",
                element: <CityCreate />,
              },
              {
                path: ":id",
                element: <CityDetail />,
                loader: cityLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <CityEdit />,
                loader: cityLoader(queryClient),
              },
            ],
          },
          {
            path: "province",
            children: [
              {
                index: true,
                element: <ProvinceIndex />,
              },
              {
                path: "create",
                element: <ProvinceCreate />,
              },
              {
                path: ":id",
                element: <ProvinceDetail />,
                loader: provinceLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <ProvinceEdit />,
                loader: provinceLoader(queryClient),
              },
            ],
          },
          {
            path: "category-bizzpass",
            children: [
              {
                index: true,
                element: <BuildingIndex />,
              },
              {
                path: "create",
                element: <BuildingCreate />,
              },
              {
                path: ":id",
                element: <BuildingDetail />,
                loader: buildingLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <BuildingEdit />,
                loader: buildingLoader(queryClient),
              },
            ],
          },
          {
            path: "organization",
            children: [
              {
                index: true,
                element: <OrganizationIndex />,
              },
              {
                path: "create",
                element: <OrganizationCreate />,
              },
              {
                path: ":id",
                element: <OrganizationDetail />,
                loader: organizationLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <OrganizationEdit />,
                loader: organizationLoader(queryClient),
              },
            ],
          },
          {
            path: "master-param",
            children: [
              {
                index: true,
                element: <MasterParamIndex />,
              },
              {
                path: "create",
                element: <MasterParamCreate />,
              },
              {
                path: ":id",
                element: <MasterParamDetail />,
                loader: masterParamLoader(queryClient),
              },
              {
                path: ":id/edit",
                element: <MasterParamEdit />,
                loader: masterParamLoader(queryClient),
              },
            ],
          },
          // FROM e2e-phase2.routes.tsx
          {
            path: "master-matrix-approval",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.SYS_ADMIN,
                        ROLE.ADMINISTRATOR,
                        ROLE.SYS_ADMIN_VIEW,
                      ]}
                    >
                      <MasterMatrixApprovalIndex keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "create",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate roles={[ROLE.SYS_ADMIN, ROLE.ADMINISTRATOR]}>
                      <MasterMatrixApprovalCreate keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: ":id",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.SYS_ADMIN,
                        ROLE.ADMINISTRATOR,
                        ROLE.SYS_ADMIN_VIEW,
                      ]}
                    >
                      <MasterMatrixApprovalDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      ...e2eRoutes,
      ...rebuildRoutes,
      ...e2ePhase2Routes,
      ...abdBackboneRoutes,
      {
        path: "notifications",
        element: <NotificationIndex />,
      },
    ],
  },
  {
    path: "/map/:id",
    element: (
      <UserGate>
        <MapIndex />
      </UserGate>
    ),
  },
];
